
















































































































































































import { StudyList } from "../ts/StudyList";
export default StudyList;
